import { Alert } from '../../alerts/models/Alert';
import { LineChartViewerVm } from '../utils/viewer-builder/builders/buildLineChartViewer';

export const DIAGNOSTIC_PROPERTY_TYPES = {
    TEXT: 'text',
    LIST: 'list',
    RS100_COMPAT: 'rs100Compat',
    LINE_CHART: 'lineChart',
} as const;

interface BaseDiagnosticVm {
    id: string;
    label: string;
    alert: Alert | null;
    statusInformation?: string;
}

interface TextDiagnosticPropertyVm extends BaseDiagnosticVm {
    type: typeof DIAGNOSTIC_PROPERTY_TYPES.TEXT;
    value: string;
}

interface ListDiagnosticPropertyVm extends BaseDiagnosticVm {
    type: typeof DIAGNOSTIC_PROPERTY_TYPES.LIST;
    values: string[];
}

interface Rs100CompatDiagnosticPropertyVm extends BaseDiagnosticVm {
    type: typeof DIAGNOSTIC_PROPERTY_TYPES.RS100_COMPAT;
}

interface LineChartDiagnosticPropertyVm extends BaseDiagnosticVm {
    type: typeof DIAGNOSTIC_PROPERTY_TYPES.LINE_CHART;
    lineChartData: Pick<LineChartViewerVm, 'value' | 'config'>;
}

export type DeviceDiagnosticPropertyItemVm =
    | TextDiagnosticPropertyVm
    | ListDiagnosticPropertyVm
    | Rs100CompatDiagnosticPropertyVm
    | LineChartDiagnosticPropertyVm;

export interface DiagnosticSection {
    id: string;
    title: string;
    properties: DeviceDiagnosticPropertyItemVm[];
}

export interface DeviceDiagnosticSectionVm extends DiagnosticSection {
    refreshVisible: boolean;
    refreshing: boolean;
    refreshDisabled: boolean;
    refreshTooltip: string;
}
